'use strict';

var React = require('react');
var Router = require('react-router');
var Link = Router.Link;

module.exports = React.createClass({

	displayName: 'MenuButtons',

	propTypes: {
		model: React.PropTypes.object.isRequired,
		query: React.PropTypes.object,
		pathname: React.PropTypes.string.isRequired
	},

	_renderMenuIsOpen: function(){

		var menuQuery = Object.assign({}, this.props.query);
		delete menuQuery.menuActive;

		var searchQuery = Object.assign({}, this.props.query);
		searchQuery.searchbarActive = true;

		// Menu should not be open at the same time as search
		delete searchQuery.menuActive;

		return (
			[

				<div key="1" className="svtse_menu__btn-area-left">
					<Link to={this.props.pathname} query={menuQuery} className="svtse_menu__menu-btn" aria-expanded="true">
						<span className="svtse_menu__menu-btn-icon-container">
							<span className="svtse_menu__menu-btn-icon svtse_menu__menu-btn-icon--is-toggled"></span>
						</span>
					</Link>
				</div>,
				<div key="2" className="svtse_menu__btn-area-right">
					<Link className="svtse_menu__search-btn"
						to={this.props.pathname} query={searchQuery}>
						<span className="svtse_menu__search-icon"></span>
					</Link>
				</div>

			]
		);
	},

	_renderNothingIsOpen: function() {

		var menuQuery = Object.assign({}, this.props.query);
		menuQuery.menuActive = true;

		var searchQuery = Object.assign({}, this.props.query);
		searchQuery.searchbarActive = true;

		return (
			[
				<div key="1" className="svtse_menu__btn-area-left">
					<Link to={this.props.pathname} query={menuQuery} className="svtse_menu__menu-btn" aria-expanded="false" aria-haspopup="true" aria-controls="svtse_a11y-small-memu">
						<span className="svtse_menu__menu-btn-icon-container">
							<span className="svtse_menu__menu-btn-icon"></span>
						</span>
					</Link>
				</div>,
				<div key="2" className="svtse_menu__btn-area-right">
						<Link className="svtse_menu__search-btn"
							to={this.props.pathname} query={searchQuery}>
								<span className="svtse_menu__search-icon"></span>
						</Link>
				</div>
			]
		);
	},

	_renderSearchIsOpen: function() {

		var searchQuery = Object.assign({}, this.props.query);
		searchQuery.searchbarActive = false;
		delete searchQuery.searchbarActive;

		return (
			<div className="svtse_menu__btn-area-right">
				<Link className="svtse_menu__cancel-link" to={this.props.pathname} query={searchQuery}>
					AVBRYT
				</Link>
			</div>
		);
	},


	render: function () {

		// Search is Open - action can be Open Menu, Close search
		if(this.props.query && this.props.query.searchbarActive) {
			return (
				<header className="svtse_menu--void" role="banner">
					{this._renderSearchIsOpen()}
				</header>
			);
		}

		// Menu is Open - action can be : Close Menu, Open Search
		if(this.props.query && this.props.query.menuActive) {
			return (
				<header className="svtse_menu--void" role="banner">
					{this._renderMenuIsOpen()}
				</header>
			);
		}

		// Nothing is Open - action can be : Open Menu, Open Search
		return (
			<header className="svtse_menu--void" role="banner">
				{this._renderNothingIsOpen()}
			</header>
		);

	}
});




/** WEBPACK FOOTER **
 ** ./app/components/menu/MenuButtons.js
 **/